export const PROD_API_KEY = "AIzaSyDAaigUCtX7s17vxVZIELxUzkuzL77c514";
export const PROD_AUTH_DOMAIN = "mileage-67fd7.firebaseapp.com";
export const PROD_DATABASE_URL = "https://mileage-67fd7.firebaseio.com";
export const PROD_PROJECT_ID = "mileage-67fd7";
export const PROD_STORAGE_BUCKET = "";
export const PROD_MESSAGING_SENDER_ID = "174152063830";


export const DEV_API_KEY = "AIzaSyDAaigUCtX7s17vxVZIELxUzkuzL77c514";
export const DEV_AUTH_DOMAIN = "mileage-67fd7.firebaseapp.com";
export const DEV_DATABASE_URL = "https://mileage-67fd7.firebaseio.com";
export const DEV_PROJECT_ID = "mileage-67fd7";
export const DEV_STORAGE_BUCKET = "";
export const DEV_MESSAGING_SENDER_ID = "174152063830";

// google web sdk?
// Web client ID: 604228586503-llnil1sj6n7k2m1dftrjjmplkgs5kq6o.apps.googleusercontent.com
// Web client secret: t4nQ_Upq2BR37bRCI2uhbL49


// WEBPACK FOOTER //
// ./src/constants/firebase.js